<template>
    <div>
        <v-card v-show="!showItemPicker">
            <v-toolbar flat color="info" height="40" >
                <v-toolbar-title>
                    {{title}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="closePromotionEdit()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-form ref="itemPromotionform" v-model="itemFormValid" lazy-validation>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.itemNumber" 
                                label="Item No"
                                :readonly="true"
                                type="text"
                                >
                                    <v-menu
                                    slot="append-outer"
                                    style="top: -12px"
                                    offset-y
                                    >
                                        <v-btn slot="activator" color="primary" @click="showItemPicker=true">
                                            Pick Item
                                        </v-btn>

                                    </v-menu>
                                </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field 
                                v-model="itemData.itemDesc" 
                                label="Item Desc."
                                readonly
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs7 pa-1 >
                            <v-select
                                :rules="[rules.required]"
                                :items="promotionTypes"
                                item-text="name"
                                item-value="id"
                                v-model="itemData.promotionType"
                                label="Promotion Type"
                                hint=""
                                persistent-hint
                                ></v-select>
                        </v-flex>
                        <v-flex xs5 pa-1>
                            <v-text-field 
                                :rules="[rules.required, promotionCodeRule]"
                                v-model="itemData.promotionCode" 
                                label="Promotion Code"
                                hint="Must be 8 Characters or Number"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs12 pa-1 v-if="!isBuyXGetY">

                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.promotionAmt" 
                                type="number"
                                :label="promotionAmtTextboxLabel"
                                v-bind="promotionSymbol"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pa-1 v-if="isBuyXGetY">
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.buyXGetYFreeBuyQty" 
                                type="number"
                                label="Buy Qty."
                                v-bind="promotionSymbol"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pa-1 v-if="isBuyXGetY">
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.buyXGetYFreeGetQty" 
                                type="number"
                                label="Get Free Qty."
                                v-bind="promotionSymbol"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs12 pa-1>
                            <v-text-field 
                                v-model="itemData.uom" 
                                label="Apply to Unit"
                                hint="If empty, discount could be applied to all Unit"
                                persistent-hint
                                ></v-text-field>
                        </v-flex>


                        <!-- <v-flex xs12 >
                            <v-checkbox
                                v-model="itemData.autoApply"
                                label="Apply Promotion To Quote Item Automatically"
                                data-vv-name="checkbox"
                                type="checkbox"
                            ></v-checkbox>
                        </v-flex> -->
                        <v-flex xs6 pa-1>
                            <v-menu
                                v-model="startDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                :rules="[rules.required]"
                                slot="activator"
                                v-model="itemData.startDate"
                                label="Start Date"
                                hint="yyyy-mm-dd"
                                readonly
                                ></v-text-field>
                                <v-date-picker v-model="itemData.startDate" @input="startDateMenu = false" 
                                no-title ></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs6 pa-1>
                            <v-menu
                                v-model="endDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                slot="activator"
                                v-model="itemData.endDate"
                                label="End Date"
                                hint="yyyy-mm-dd"
                                readonly
                                ></v-text-field>
                                <v-date-picker v-model="itemData.endDate" @input="endDateMenu = false" 
                                no-title ></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs6 pa-1>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.minQty" 
                                type="number"
                                label="Min. Qty"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pa-1>
                            <v-text-field 
                                v-model="itemData.maxQty" 
                                type="number"
                                label="Max. Qty"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs12 pa-1>
                            <v-textarea
                                label="Notes"
                                rows="3"
                                counter="300"
                                maxlength="300"
                                v-model="itemData.notes"
                                hint=""
                                persistent-hint
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs-12 pt-3 class="text-xs-center">
                            <v-btn :disabled="!itemFormValid" @click="onSaveItem">Submit</v-btn>
                        </v-flex>
                    </v-layout>

                </v-card-text>

            </v-form>

            <!-- {{itemData}}
            {{ originalPromotionData }} -->
        </v-card>
            <ctlItemSearch @onItemPicked="onItemPicked" v-show="showItemPicker"></ctlItemSearch>
    </div>
</template>
<script>
import ctlItemSearch from '@/components/ctlItemSearch'
import { mapGetters, mapActions } from "vuex";

export default {
    props: ['originalPromotionData'],
    components: {
        ctlItemSearch
    },
    data () {
        return {
            promotionTypes: [
                {id: 'DiscountPct', name: 'Discount Percentage'},
                {id: 'PromotionPrice', name: 'Promotion Price'},
                {id: 'BuyXGetYFree', name: 'Buy X Get Y Free'}
            ],
            itemData: {promotionCodeRule: ''},
            showItemPicker: false,
            startDateMenu: false,
            endDateMenu: false,
            itemFormValid: false,
            rules: {
                required: v => !!v || "This field is required"
            },
        }
    },
    computed: {
        isNew () {
            return !this.originalPromotionData.id
        },
        title () {
            return this.isNew? 'Add Promotion' : 'Edit Promotion'
        },
        isBuyXGetY () {
            return this.itemData.promotionType == 'BuyXGetYFree'
        },
        promotionAmtTextboxLabel () {
            if (this.itemData.promotionType == 'DiscountPct') {
                return 'Discount Percentage'
            }
            if (this.itemData.promotionType == 'PromotionPrice') {
                return 'Promotion Price'
            }
        },
        promotionSymbol() {
            if (this.itemData.promotionType === 'DiscountPct') {
            return { suffix: '%' };
            }
            if (this.itemData.promotionType === 'PromotionPrice') {
            return { prefix: '$' };
            }
            return {};
        }
    },
    methods: {
        ...mapActions('adminItemPromotion', [
            'saveItemPromotion',
        ]),
        promotionCodeRule(value) {
            const pattern = /^[a-zA-Z0-9]{8}$/
            return pattern.test(value) || 'Code must be exactly 8 characters or numbers'
        },
        onItemPicked (itemDataPicked) {
            this.showItemPicker = false
            if(itemDataPicked) {
                console.log(itemDataPicked);
                this.itemData = Object.assign({}, this.itemData, {
                    itemNumber: itemDataPicked.itemNumber,
                    itemDesc: itemDataPicked.description,
                    uom: itemDataPicked.unit,
                    itemId: itemDataPicked.itemId,
                })
            }
        },
        closePromotionEdit () {
            this.$emit('onClosePromotionPopup', null)
        },
        // if itemDataToSave == null,it means we will close this popup
        async onSaveItem () {
            // console.table(itemDataToSave)
            if (this.$refs.itemPromotionform.validate()) {
                
                var result = await this.saveItemPromotion(this.itemData)
                this.$emit('onClosePromotionPopup', this.itemData)
                //reset data for reuse next time
                this.itemData = {}
            }
        }
    },
    watch: {
        originalPromotionData (value) {
            // console.log('originalitemchanged')
            // console.table(value)
            // if (value.itemId) {
            //     this.itemData = {}
            //     this.isCustomItem = false
            // } else {
                this.itemData = Object.assign({}, this.originalPromotionData)
                // if it has itemId, it is an HealthMark inventory item
console.log("this.itemData")
console.log(this.itemData)
            // }

        }
    },
    created() {

    }
}
</script>
